import lsService from '@/services/LocalStorageService'
const EG_NOTE_HISTORIES_KEY = 'EG_NOTE_HISTORIES'
const EG_NOTE_HISTORIES_MAX = 20

class NoteHistoryService {
  constructor() {
    this._noteGuids = lsService.restore(EG_NOTE_HISTORIES_KEY, [])
  }

  get noteGuids() {
    if (this._noteGuids) {
      return this._noteGuids
    }
    return []
  }

  put(guid) {
    if (!guid) {
      return
    }

    const i = this._noteGuids.indexOf(guid)
    if (i >= 0) {
      this._noteGuids.splice(i, 1)
    }

    this._noteGuids.unshift(guid)

    const d = this._noteGuids.length - EG_NOTE_HISTORIES_MAX
    if (d > 0) {
      this._noteGuids.splice(EG_NOTE_HISTORIES_MAX, d)
    }

    lsService.save(EG_NOTE_HISTORIES_KEY, this._noteGuids)

    // console.log(this._noteGuids)
  }

  reset() {
    this._noteGuids = []
    lsService.save(EG_NOTE_HISTORIES_KEY, this._noteGuids)
  }

  clear() {
    lsService.remove(EG_NOTE_HISTORIES_KEY)
  }
}

const noteHistoryService = new NoteHistoryService()
export default noteHistoryService
